import './App.css';

import { HashRouter, Routes, Route } from "react-router-dom";
import Navbar from './Components/Navbar/Navbar';
import PageHome from './Pages/PageHome/PageHome';
import NoPage from './Pages/NoPage/NoPage';
import PageContact from './Pages/PageContcat/PageContact';
import PageEgzaminy from './Pages/PageEgzaminy/PageEgzaminy';
import INFtrojka from './Pages/PageEgzaminy/MiniPagesEgzamin/INF03/INFtrojka';
import Rozwiazanie from './Pages/PageEgzaminy/MiniPagesEgzamin/INF03/Rozwiazanie';
import PageINFpodglad from './Pages/PageEgzaminy/MiniPagesEgzamin/INF03/PageINFpodglad';
import Footer from './Components/Footer/Footer';
import PageMaterials from './Pages/PageMaterials/PageMaterials';
import ScrollToTop from './Components/Scroll/ScrollToTop';
import Twimbazyxamp from './Pages/PageEgzaminy/MiniPagesEgzamin/INF03/Sidebarhelps/Wskazowki/Twimbazyxamp';
import Connclosexampp from './Pages/PageEgzaminy/MiniPagesEgzamin/INF03/Sidebarhelps/Wskazowki/Connclosexampp';
import Crudphpxampp from './Pages/PageEgzaminy/MiniPagesEgzamin/INF03/Sidebarhelps/Wskazowki/Crudphpxampp';
import Bzsql from './Pages/PageEgzaminy/MiniPagesEgzamin/INF03/Sidebarhelps/Rodzajezadan/Bzsql';
import Skrphp from './Pages/PageEgzaminy/MiniPagesEgzamin/INF03/Sidebarhelps/Rodzajezadan/Skrphp';
import Skrjs from './Pages/PageEgzaminy/MiniPagesEgzamin/INF03/Sidebarhelps/Rodzajezadan/Skrjs';
import Grafika from './Pages/PageEgzaminy/MiniPagesEgzamin/INF03/Sidebarhelps/Rodzajezadan/Grafika';
import Teoriainf3 from './Pages/PageEgzaminy/MiniPagesEgzamin/INF03/Sidebarhelps/Potworka/Teoriainf3';
import Praktykainf3 from './Pages/PageEgzaminy/MiniPagesEgzamin/INF03/Sidebarhelps/Potworka/Praktykainf3';
import ScrollToElement from './Components/Scroll/ScrollToElement';
import Sidebarhelp from './Pages/PageEgzaminy/MiniPagesEgzamin/INF03/Sidebarhelps/Sidebarhelp';
import Rozwiazanieczworka from './Pages/PageEgzaminy/MiniPagesEgzamin/INF04/Rozwiazanieczworka';
import INFczworka from './Pages/PageEgzaminy/MiniPagesEgzamin/INF04/INFczworka';
import Sidebarhelp04 from './Pages/PageEgzaminy/MiniPagesEgzamin/INF04/Sidebarhelps/Sidebarhelp04';
import TestINFtrojka from './Pages/PageEgzaminy/MiniPagesEgzamin/INF03/TestINFtrojka';
import PagePolityka from './Pages/PagePolityka/PagePolityka';

function App() {
  return ( 
    <div className="App" >
        <HashRouter>
        <Navbar />
        <ScrollToTop />
        <ScrollToElement/>
        <Routes> 
          <Route path="/" element={<PageHome />} />
          <Route path="/contact" element={<PageContact />} />
          <Route path="/materialy" element={<PageMaterials />} />
          <Route path="/egzaminy" element={<PageEgzaminy />} />

          <Route path="/polityka" element={<PagePolityka />} />

          {/* INF03 */}
            <Route path="/egzaminy/inf03" element={<INFtrojka />} />
            <Route path="/egzaminy/inf03/test" element={<TestINFtrojka />} />
            <Route path="/rozwiazanie/:klasyfikacja/:rok/:examId" element={<Rozwiazanie />} />
            <Route path="/podgladinf03/:klasyfikacja/:rok/:examId" element={<PageINFpodglad />} />
            {/* SidebarINF03 */}
              <Route path="/egzaminy/inf03/sidebarhelp" element={<Sidebarhelp />} />\
              <Route path="/egzaminy/inf03/bazadanychsql" element={<Bzsql />} />\
              <Route path="/egzaminy/inf03/skryptphp" element={<Skrphp />} />
              <Route path="/egzaminy/inf03/skryptjs" element={<Skrjs />} />
              <Route path="/egzaminy/inf03/grafika" element={<Grafika />} />
              <Route path="/egzaminy/inf03/tworzenieimportowaniexampp" element={<Twimbazyxamp />} />
              <Route path="/egzaminy/inf03/laczenieizamykaniexampp" element={<Connclosexampp />} />
              <Route path="/egzaminy/inf03/crudphpxampp" element={<Crudphpxampp />} />
              <Route path="/egzaminy/inf03/teoria" element={<Teoriainf3 />} />
              <Route path="/egzaminy/inf03/praktyka" element={<Praktykainf3 />} />

          {/* INF04 */}
          <Route path="/egzaminy/inf04" element={<INFczworka />} />
            <Route path="/rozwiazanie04/:klasyfikacja/:rok/:examId" element={<Rozwiazanieczworka />} />
            <Route path="/podgladinf04/:klasyfikacja/:rok/:examId" element={<PageINFpodglad />} />
            {/* SidebarINF04 */}
              <Route path="/egzaminy/inf04/sidebarhelp" element={<Sidebarhelp04 />} />\

          <Route path="*" element={<NoPage />} />
        </Routes>
        <Footer></Footer>
      </HashRouter>
    </div>
  );
}

export default App;
